module.exports = __webpack_public_path__ + "img/c51a1c5.jpg";